import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import {Typography, IconButton} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '../../CommonComponents/Menu';

import {UserInfoContext} from '../../../StateObjects/UserInfoContext';

import {RequestStatusId,RequestActionId,SnackbarSeverity, UserRole} from '../../../ApplicationConfig/constants'

export default function ActionsMenu(props) {

  let menuVar;
  
  const {controls}=props
  const {userInfo} = React.useContext(UserInfoContext);
 
  let isMyRequest=props.requester.account==userInfo.id
  
  const {t} = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const ariaControls = `actions-menu-${controls}`;
  
  const handleClick = (event) => {
    props.closeSnackbar();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseItem = (e,rowStatus) => {
    e.stopPropagation()
    setAnchorEl(null);
    props.closeSnackbar();
    props.handleAction(rowStatus);
  };

  const handleClose = (e) => {
    if (e!=undefined) {e.stopPropagation();}
    setAnchorEl(null);
  };

  const handleBlur=(event)=>{
    if (event.key === 'Tab') {
      event.preventDefault();
      setAnchorEl(null);
    }
  }

  const toggleDialog = (e, state, value, rowInfo, supportAnalysts=[]) => {
    if (e!=null) {e.stopPropagation();}
    props.toggleDialog(state, value, rowInfo, supportAnalysts)
    props.closeSnackbar();
    handleClose(e);
  };

  const handleApproveDenyRequestCallBack=(isSuccess,state,value,rowStatus)=>{
    if (isSuccess){
      toggleDialog(null, state,value,rowStatus)
    }
  }

  const handleApproveDenyRequest = (e,state,value,rowStatus)=>{
    e.stopPropagation()
    props.validateRequest(state,value,rowStatus,handleApproveDenyRequestCallBack)
    handleClose(e);
  }
  
  const handleStartReview=(e,rowStatus)=>{
    e.stopPropagation()
    props.handleAction(rowStatus)
    props.closeSnackbar();
    handleClose(e);
  }

  let supportAnalyst=props.supportAnalysts.find(el=>el.account==userInfo.id);
  
  const duplicateMenuItem=()=>{
    return;
    //Commented out for now
    /*if (isMyRequest){
      return (<MenuItem 
      key={props.requestId + RequestActionId.Duplicate} onClick={(e)=> handleCloseItem(e,
      {requestId:props.requestId,
      actionId:RequestActionId.Duplicate,
      severity:SnackbarSeverity.Success,
      message:t('notifications.vettingRequestDuplicated')})}>
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.duplicate')}</Typography>} />
      </MenuItem>)
    }*/
  }

  const requesterDetailsMenuItem=()=>{
    return(
      <MenuItem
        key={props.requestId + "_requester"}
        id="requesterDetails-action"
        onClick={(e) => {
          toggleDialog(e, 'dialogRequesterDetails', true, props.requester)
        }}
      >
        <ListItemText
          primary={
            <Typography variant="body2">{t('contextMenu.requesterDetails')}</Typography>
          }
        />
      </MenuItem>
    )
  }

  const assigneeDetailsMenuItem=()=>{
    if ((userInfo.role==UserRole.Researcher && props.analyst.account.length>0) ||
    (userInfo.role==UserRole.Analyst && (props.analyst.account.length>0 || props.supportAnalysts.length > 0)))
    {
      return (
        <MenuItem
          key={props.requestId + "_assignee"}
          id="assigneeDetails-action"
          onClick={(e) => {
            toggleDialog(e, 'dialogAssigneeDetails', true, props.analyst, props.supportAnalysts);
          }}
        >
          <ListItemText
            primary={
              <Typography variant="body2">{t('contextMenu.assigneeDetails')}</Typography>
            }
          />
        </MenuItem>
      )
    }
  }

  const withdrawMenuItem=()=>{
    if (isMyRequest){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.Withdrawn} 
          id="withdraw-action"
          onClick={(e)=> {
            toggleDialog(e, 'dialogWithdraw', true,{
              requestId:props.requestId,
              actionId:RequestStatusId.Withdrawn,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestWithdrawn'),
              reason:''
            })
          }}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.withdraw')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const editMenuItem=()=>{
    if ((userInfo.role==UserRole.Analyst && userInfo.id==props.analyst.account) ||
    (userInfo.role==UserRole.Researcher && isMyRequest)){
      return (
        <MenuItem 
          key={props.requestId + RequestActionId.Edit} 
          id="edit-action" 
          onClick={(e)=> handleCloseItem(e,{requestId:props.requestId,actionId:RequestActionId.Edit})}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.edit')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const viewMenuItem=()=>{
    return (
      <MenuItem 
        key={props.requestId + RequestActionId.View} 
        id="view-action" 
        onClick={(e)=> handleCloseItem(e,{requestId:props.requestId,actionId:RequestActionId.View})}
      >
        <ListItemText primary={<Typography variant="body2">{t('contextMenu.view')}</Typography>} />
      </MenuItem>
    )
  }

  const summaryMenuItem=()=>{
    return (
      <MenuItem 
        key={props.requestId + RequestActionId.OpenSummary} 
        id="summary-action" 
        onClick={(e)=> handleCloseItem(e,{requestId:props.requestId,actionId:RequestActionId.OpenSummary})}
      >
        <ListItemText primary={<Typography variant="body2">{t('contextMenu.summary')}</Typography>} />
      </MenuItem>
    )
  }

  const manageTeamMenuItem=()=>{
    if (userInfo.role==UserRole.Analyst ){
      return (
        <MenuItem 
          key={props.requestId + '_manageTeam'} 
          id="manageAssignees-action" 
          onClick={(e)=> handleCloseItem(e,{requestId:props.requestId,actionId:RequestActionId.OpenManageTeam})}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.manageTeam')}</Typography>} />
        </MenuItem>
      )
    }
  }
  
  const reactivateRequestMenuItem=()=>{
    //set the reactivate request button
    if (userInfo.role==UserRole.Analyst){
      //if current user is the primary analyst on the request
      if (props.analyst.account.length>0 && props.analyst.account==userInfo.id || supportAnalyst!=undefined){
        return (
          <MenuItem 
            key={props.requestId + RequestActionId.ReactivateRequest} 
            id="reactivate-action" 
            onClick={(e)=> handleCloseItem(e,{
              requestId:props.requestId,
              actionId:RequestActionId.ReactivateRequest,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestReopened'),
              phoneNumber:supportAnalyst!=undefined?supportAnalyst.phoneNumber:props.analyst.phoneNumber
            })}
          >
            <ListItemText primary={<Typography variant="body2">{t('contextMenu.reopen')}</Typography>} />
          </MenuItem>
        )
      }else{
        return (
          <MenuItem 
            key={props.requestId + RequestActionId.ReactivateRequest} 
            id="reactivate-action"
            onClick={(e)=> {
              toggleDialog(e, 'dialogAssignAsLead', true,{
                requestId:props.requestId,
                actionId:RequestActionId.ReactivateRequest,
                severity:SnackbarSeverity.Success,
                message:t('notifications.vettingRequestReopened'),
                phoneNumber:''
              })
            }}
          >
            <ListItemText primary={<Typography variant="body2">{t('contextMenu.reopen')}</Typography>} />
          </MenuItem>
        )
      }
    } else if (userInfo.role==UserRole.Researcher && isMyRequest){
      return (
      <MenuItem 
        key={props.requestId + RequestActionId.Draft} 
        id="reactivate-action" 
        onClick={(e)=> handleCloseItem(e,{
          requestId:props.requestId,
          actionId:RequestStatusId.Draft,
          severity:SnackbarSeverity.Success,
          message:t('notifications.vettingRequestReopened')
        })}
      >
        <ListItemText primary={<Typography variant="body2">{t('contextMenu.reopen')}</Typography>} />
      </MenuItem>)
    }
  }

  const assignToMePrimaryMenuItem=()=>{
    if (props.analyst.account!=userInfo.id){
      //if current user isn' a support analyst of this request
      if (supportAnalyst==undefined){
        return(
          <MenuItem 
            key={props.requestId + RequestActionId.AssignToMePrimary} 
            id="assignAsLead-action"
            onClick={(e) => {
              toggleDialog(e, 'dialogAssignAsLead', true,{
                requestId:props.requestId,
                actionId:RequestActionId.AssignToMePrimary,
                severity:SnackbarSeverity.Success,
                message:t('notifications.vettingRequestAssignToMe'),
                phoneNumber:''
              })
            }}
          > 
            <ListItemText primary={<Typography variant="body2">{t('contextMenu.assignToMe')}</Typography>} />
          </MenuItem>
        )
      }else {
        //the current logged in analyst is a support analyst binded to this request
        return (
          <MenuItem 
            key={props.requestId + RequestActionId.AssignToMePrimary} 
            id="assignAsLead-action" 
            onClick={(e)=> handleCloseItem(e,{
              requestId:props.requestId,
              actionId:RequestActionId.AssignToMePrimary,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestAssignToMe'),
              phoneNumber:supportAnalyst.phoneNumber
            })}
          >
            <ListItemText primary={<Typography variant="body2">{t('contextMenu.assignToMe')}</Typography>} />
          </MenuItem>
        )
      }
    }
  }

  const updateRequestedMenuItem=()=>{
    if (userInfo.id==props.analyst.account){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.UpdateRequest} 
          id="requestChanges-action" 
          onClick={(e)=> {
            toggleDialog(e, 'dialogUpdate',true,{
              requestId:props.requestId,
              actionId:RequestStatusId.UpdateRequest,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestUpdateRequested'),
              comment:''
            })
          }} 
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.requestUpdate')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const denyMenuItem=()=>{
    if (userInfo.id==props.analyst.account){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.Denied} 
          id="deny-action" 
          onClick={(e) =>{ 
            props.closeSnackbar();
            handleApproveDenyRequest(e,'dialogDenied', true,{
              requestId:props.requestId,
              actionId:RequestStatusId.Denied,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestDenied'),
              billableHours:0,
              reason_id:0,
              reason_comment:''
            })}
          }
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.denyRequest')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const assignToMeSupportMenuItem=()=>{
    if (props.analyst.account==userInfo.id){
      return (
        <MenuItem 
          key={props.requestId + RequestActionId.AssignToMeSupport} 
          id="assignAsSupport-action" 
          onClick={(e) => {
            toggleDialog(e, 'dialogNoLead', true,{
              requestId:props.requestId,
              actionId:RequestActionId.AssignToMeSupport,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestAssignAsSupport'),
              phoneNumber:'',
              noLead: true
            })
          }}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.makeMeSupport')}</Typography>} />
        </MenuItem>
      )
    }else if (props.supportAnalysts.find(el=>el.account==userInfo.id)==undefined){
      return (
        <MenuItem 
          key={props.requestId + RequestActionId.AssignToMeSupport} 
          id="assignAsSupport-action" 
          onClick={(e) => {
            toggleDialog(e, 'dialogAssignAsSupport', true,{
              requestId:props.requestId,
              actionId:RequestActionId.AssignToMeSupport,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestAssignAsSupport'),
              phoneNumber:'',
              noLead: false
            })
          }}
        > 
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.makeMeSupport')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const unassignFromMeMenuItem=()=>{
    if (props.analyst.account==userInfo.id){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.UnassignFromMe} 
          id="unassign-action"
          onClick={(e)=> {
            toggleDialog(e, 'dialogNoLead', true,{
              requestId:props.requestId,
              actionId:RequestActionId.UnassignFromMe,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestUnassigned')
            })
          }}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.unassignMe')}</Typography>} />
        </MenuItem>
      )
    }else if (props.supportAnalysts.find(el=>el.account==userInfo.id)!=undefined){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.UnassignFromMe} 
          id="unassign-action" 
          onClick={(e)=> handleCloseItem(e,{
            requestId:props.requestId,
            actionId:RequestActionId.UnassignFromMe,
            severity:SnackbarSeverity.Success,
            message:t('notifications.vettingRequestUnassigned')
          })}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.unassignMe')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const approveMenuItem=()=>{
    if (userInfo.id==props.analyst.account){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.Approved} 
          id="approve-action" 
          onClick={(e)=> {
            props.closeSnackbar();
            handleApproveDenyRequest(e,'dialogApproved', true,{
            requestId:props.requestId,
            actionId:RequestStatusId.Approved,
            severity:SnackbarSeverity.Success,
            message:t('notifications.vettingRequestApproved'),
            billableHours:0}
            )
          }}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.approve')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const startReviewMenuItem=()=>{
    if (props.analyst.account==userInfo.id){
      return (
        <MenuItem 
          key={props.requestId + RequestStatusId.DisclosureAnalysis} 
          id="startReview-action" 
          onClick={(e)=> handleStartReview(e,{
            requestId:props.requestId,
            actionId:RequestStatusId.DisclosureAnalysis,
            severity:SnackbarSeverity.Success,
            message:t('notifications.vettingRequestStartReview')
          })}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.startReview')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const deleteMenuItem=()=>{
    if (isMyRequest && props.status === RequestStatusId.Draft && !props.hasBeenReviewed){
      return(
        <MenuItem 
          key={props.requestId + RequestActionId.Delete} 
          id="delete-action" 
          onClick={(e)=> {
            toggleDialog(e, 'dialogDelete', true,{
              requestId:props.requestId,
              actionId:RequestActionId.Delete,
              severity:SnackbarSeverity.Success,
              message:t('notifications.vettingRequestDeleted')
            })
          }}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.delete')}</Typography>} />
        </MenuItem>
      )
    }
  }

  const resubmitMenuItem=()=>{
    if (isMyRequest){
      return (
        <MenuItem 
          key={props.requestId + RequestActionId.Resubmit} 
          id="submit-action" 
          onClick={(e)=> handleCloseItem(e,{
            requestId:props.requestId,
            actionId:RequestActionId.Resubmit,
            severity:SnackbarSeverity.Success,
            message:t('notifications.vettingRequestSubmitted')
          })}
        >
          <ListItemText primary={
            <Typography variant="body2">
              {t('contextMenu.resubmit')}
            </Typography>} 
          />
        </MenuItem>
      )
    }
  }

  const submitMenuItem=()=>{
    if (isMyRequest){
      return (
        <MenuItem 
          key={props.requestId + RequestActionId.Submit} 
          id="submit-action"
          onClick={(e)=> handleCloseItem(e,{
          requestId:props.requestId,
          actionId:RequestActionId.Submit,
          severity:SnackbarSeverity.Success,
          message:t('notifications.vettingRequestSubmitted')})}
        >
          <ListItemText primary={<Typography variant="body2">{t('contextMenu.submit')}</Typography>} />
        </MenuItem>
      )
    }
  }

  if (userInfo.role==UserRole.Analyst){
    switch(props.status){
      case RequestStatusId.Submitted:
        if(props.analyst.account==userInfo.id){
          menuVar = [
            viewMenuItem(),
            startReviewMenuItem(),
            assignToMePrimaryMenuItem(),
            assignToMeSupportMenuItem(),
            unassignFromMeMenuItem(),
            manageTeamMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }else{
          menuVar = [
            viewMenuItem(),
            assignToMePrimaryMenuItem(),
            assignToMeSupportMenuItem(),
            unassignFromMeMenuItem(),
            manageTeamMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }
        break;
      case RequestStatusId.Draft:
      case RequestStatusId.UpdateRequest:
        menuVar = [
          viewMenuItem(),
          assignToMePrimaryMenuItem(),
          assignToMeSupportMenuItem(),
          unassignFromMeMenuItem(),
          manageTeamMenuItem(),
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.Withdrawn:
        menuVar = [
          viewMenuItem(),
          manageTeamMenuItem(),
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.Approved:
      case RequestStatusId.Denied:
        menuVar = [
          viewMenuItem(),
          reactivateRequestMenuItem(),
          duplicateMenuItem(),
          assigneeDetailsMenuItem(),
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.DisclosureAnalysis:
        if(userInfo.id!=props.analyst.account){
          menuVar = [
            editMenuItem(),
            approveMenuItem(),
            denyMenuItem(),
            updateRequestedMenuItem(),
            viewMenuItem(),
            assignToMePrimaryMenuItem(),
            assignToMeSupportMenuItem(),
            unassignFromMeMenuItem(),
            manageTeamMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }else{
          menuVar = [
            editMenuItem(),
            approveMenuItem(),
            denyMenuItem(),
            updateRequestedMenuItem(),
            assignToMePrimaryMenuItem(),
            assignToMeSupportMenuItem(),
            unassignFromMeMenuItem(),
            manageTeamMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }
        break;
    }
  }else if (userInfo.role==UserRole.Researcher){
    switch(props.status){
      case RequestStatusId.Submitted:
        menuVar = [
          viewMenuItem(),
          duplicateMenuItem(),
          withdrawMenuItem(),
          assigneeDetailsMenuItem(),
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.Draft:
        if(!isMyRequest){
          menuVar = [
            duplicateMenuItem(),
            editMenuItem(),
            viewMenuItem(),
            submitMenuItem(),
            assigneeDetailsMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem(),
            deleteMenuItem()
          ];
        }else{
          menuVar = [
            duplicateMenuItem(),
            editMenuItem(),
            submitMenuItem(),
            assigneeDetailsMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem(),
            deleteMenuItem()
          ];
        }
        break;
      case RequestStatusId.UpdateRequest:
        if(!isMyRequest){
          menuVar = [
            duplicateMenuItem(),
            editMenuItem(),
            viewMenuItem(),
            resubmitMenuItem(),  
            withdrawMenuItem(),
            assigneeDetailsMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }else{
          menuVar = [
            duplicateMenuItem(),
            editMenuItem(),
            resubmitMenuItem(), 
            withdrawMenuItem(),
            assigneeDetailsMenuItem(),
            requesterDetailsMenuItem(),
            summaryMenuItem()
          ];
        }
        break;
      case RequestStatusId.Withdrawn:
        menuVar = [
          viewMenuItem(),
          duplicateMenuItem(),
          reactivateRequestMenuItem(),
          assigneeDetailsMenuItem(),
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.Approved:
      case RequestStatusId.Denied:
        menuVar = [
          viewMenuItem(),
          duplicateMenuItem(),
          assigneeDetailsMenuItem(),   
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
      case RequestStatusId.DisclosureAnalysis:
        menuVar = [
          viewMenuItem(),
          duplicateMenuItem(),
          withdrawMenuItem(),
          assigneeDetailsMenuItem(),   
          requesterDetailsMenuItem(),
          summaryMenuItem()
        ];
        break;
    }
  }

  return (
    <div>
      <IconButton
        name="actions-menu"
        onClick={handleClick}
        aria-controls="context-menu"
        aria-haspopup="true"
        aria-label="Actions menu"
        edge="end"
        onKeyPress={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (e.key === 'Enter') {
            handleClick(e);
          }
        }}
        size="large">
        <MoreVertIcon />
      </IconButton>
      {anchorEl!==null && 
        <Menu
          id={ariaControls}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          handleClose={handleClose}
          handleBlur={handleBlur}
          content={menuVar}
        />
      }
    </div>
  );
}
ActionsMenu.propTypes={
  controls: PropTypes.number.isRequired,
  requester: PropTypes.object.isRequired,
  handleAction: PropTypes.func.isRequired,
  validateRequest: PropTypes.func.isRequired,
  supportAnalysts: PropTypes.arrayOf(PropTypes.object).isRequired,
  requestId: PropTypes.number.isRequired,
  analyst: PropTypes.object.isRequired,
  status: PropTypes.number.isRequired,
  hasBeenReviewed: PropTypes.bool.isRequired,
  closeSnackbar: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
}

// //////////////////////////// Analyst role dialog box context menu
export function AnalystMenu(props) {
  const {
    role, 
    makeSupport, 
    makeLead, 
    unassignRequest,
    controls,
    current,
    toggleAssignMeMenu
  } = props;
  let menuVar;

  const {t} = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const ariaControls = `context-menu-${controls}`;
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleBlur=(event)=>{
    if (event.key === 'Tab') {
      event.preventDefault();
      setAnchorEl(null);
    }
  }

  if (role === 'lead') {
    menuVar = [
      <MenuItem 
        key="analystmenu-assignAsSupport-item" 
        id="analystmenu-assignAsSupport-item" 
        onClick={makeSupport}
      >
        <ListItemText primary={<Typography variant="body2">{current? t('contextMenu.makeMeSupport'):t('contextMenu.makeSupport')}</Typography>} />
      </MenuItem>,
      <MenuItem 
        key="analystmenu-unassign-item" 
        id="analystmenu-unassign-item" 
        onClick={() => {
          unassignRequest();
          toggleAssignMeMenu();
        }}
      >
        <ListItemText primary={<Typography variant="body2" >{current? t('contextMenu.unassignMe'):t('contextMenu.unassign')}</Typography>} />
      </MenuItem>
    ];
  } else if (role === 'support') {
    menuVar = [
      <MenuItem 
        key="analystmenu-assignAsLead-item" 
        id="analystmenu-assignAsLead-item" 
        onClick={makeLead}
      >
        <ListItemText primary={<Typography variant="body2">{current?t('contextMenu.assignToMe'):t('contextMenu.makeLead')}</Typography>} />
      </MenuItem>,
      <MenuItem 
        key="analystmenu-unassign-item" 
        id="analystmenu-unassign-item" 
        onClick={() => {
          unassignRequest();
          toggleAssignMeMenu();
        }}
      >
        <ListItemText primary={<Typography variant="body2" >{current? t('contextMenu.unassignMe'):t('contextMenu.unassign')}</Typography>} />
      </MenuItem>
    ];
  }

  return (
    <div>
      <IconButton
        name="actions-menu"
        onClick={handleClick}
        aria-controls={ariaControls}
        aria-haspopup="true"
        aria-label="Actions menu"
        edge="end"
        size="large">
        <MoreVertIcon />
      </IconButton>
      {anchorEl!== null && 
        <Menu
          id={ariaControls}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          handleClose={handleClose}
          handleBlur={handleBlur}
          content={menuVar}
        />
      }
    </div>
  );
}
AnalystMenu.propTypes={
  role: PropTypes.string.isRequired, 
  makeSupport: PropTypes.func, 
  makeLead: PropTypes.func, 
  unassignRequest: PropTypes.func.isRequired,
  controls: PropTypes.number.isRequired,
  current: PropTypes.bool.isRequired,
  toggleAssignMeMenu: PropTypes.func.isRequired,
}